import React from "react";
import styled from "styled-components";
import ViewAppBar from "../views/ViewAppBar";
import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";
import ViewCadastroRepresentante from "../views/viewCadastroRepresentante";
import { Row } from "antd";

const CadastroRepresentante: React.FC = () => (
  <>
    <ContatoZap />
    <ViewAppBar />
    <Row>
      <ViewCadastroRepresentante />
    </Row>

    <ViewFooter />
  </>
);
export default CadastroRepresentante;
